import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { Sponsor } from '../models/Sponsor';

@Injectable()
export class SponsorsService {
  constructor(private http: HttpClient) {}

  getSponsorData(): Observable<Sponsor[]> {
    return this.http.get<any[]>('sponsors').pipe(
      map(data => data.map(d => new Sponsor(d))),
      catchError(err => {
        console.error('In getSponsorData::', err);
        return throwError(() => err);
      })
    );
  }
}
